import {Wifi, ChevronRight} from 'lucide-react';
import {useTheme} from 'styled-components';
import {useTranslation} from 'react-i18next';
import airaloBackground from './background.jpg';
import Link from 'components/common/Link';
import {AiraloTag} from './AiraloTag';
import {PATHS} from 'Routes';
import {usePath} from 'hooks';

export const AiraloWidget = () => {
  const {hasTemplate} = useTheme();
  const {t} = useTranslation();
  const {getFullPath} = usePath();

  return (
    <div
      className="flex gap-4 p-4 @lg:pr-[150px] @container-[min-width:500px]:pr-[150px] rounded-xl items-center text-[var(--font-primary,#152946)] border border-[color-mix(in_srgb,#000000_10%,var(--navigation-background))] bg-cover bg-right bg-blend-overlay"
      style={
        {
          '--airalo-background-image': `url(${airaloBackground})`,
          backgroundImage: `linear-gradient(90deg, color-mix(in srgb, var(--airalo-widget-background, #385bf8) 50%, #fff) 0%, color-mix(in srgb, var(--airalo-widget-background, #385bf8) 60%, transparent) 100%), var(--airalo-background-image)`,
        } as React.CSSProperties
      }
    >
      <div className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center [background-color:var(--background-secondary)]">
        <Wifi
          size={20}
          color={hasTemplate ? 'var(--brand-icons)' : 'var(--font-secondary)'}
        />
      </div>

      <div className="flex flex-col gap-y-2 justify-items-start">
        <div className="text-sm font-medium">{t('airalo.starting_price')}</div>
        <div className="flex gap-x-4 gap-y-2 flex-wrap">
          <div className="text-lg">{t('airalo.title')}</div>
          <div className="flex gap-2 items-center">
            <AiraloTag>{t('airalo.tag_easy_installation')}</AiraloTag>
            <AiraloTag>{t('airalo.tag_instant_data')}</AiraloTag>
          </div>
        </div>
        <Link
          className="flex items-center gap-1 ml-0 [--lucide-stroke-width:3]"
          to={getFullPath(PATHS.esim.manage)}
        >
          <span>{t('airalo.link_text')}</span>
          <ChevronRight className="inline-block" size={18} />
        </Link>
      </div>
    </div>
  );
};
